import { useMutation } from '@tanstack/react-query';
import config from '@/config';
import api from '@/shared/api';
import HandleHttpError from '@/shared/services/HandleHttpError';
import { useIntl } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import useRemoveDetailRow from './useRemoveDetailRow';
const useBillRegistration = () => {
    const { removeDetailRow } = useRemoveDetailRow();
    const intl = useIntl();
    const { mutateAsync } = useMutation(values => api.base
        .post(`${config.appUrls.api}/api/IntraCompany/BillRegistration/${values.registrationId}`)
        .then(({ data }) => data), {
        onSuccess: (invoiceId, x) => {
            if (invoiceId) {
                console.log(invoiceId);
                removeDetailRow(x);
                ToastrService.success();
            }
        },
        onError: e => {
            HandleHttpError(intl)(e);
        },
    });
    return { billRegistration: mutateAsync };
};
export default useBillRegistration;
